import { t } from "@lingui/core/macro";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { StoreHomePage } from "./StoreHomePage";
import { StoreMembershipsPage } from "./StoreMembershipsPage";
import { StorePackagesPage } from "./StorePackagesPage";
import { StoreProductDetailPage } from "./StoreProductDetailPage";
import { StoreProductOrderPage } from "./StoreProductOrderPage";

export type StoreStackNavigatorParamList = {
  StoreHome: { membershipId?: string; packageId?: string } | undefined;
  Memberships: { membershipId?: string } | undefined;
  Packages: { packageId?: string } | undefined;
  ProductDetail: { productId: string };
  ProductOrder: { productId: string; orderId: string };
};

export const StoreStackNavigator = () => {
  const Stack = createNativeStackNavigator<StoreStackNavigatorParamList>();

  return (
    <VStack flex={1}>
      <Stack.Navigator initialRouteName="StoreHome">
        <Stack.Screen
          name="StoreHome"
          component={StoreHomePage}
          options={{ headerShown: false, title: t`Store` }}
        />
        <Stack.Screen
          name="Memberships"
          component={StoreMembershipsPage}
          options={{ headerShown: false, title: t`Memberships` }}
        />
        <Stack.Screen
          name="Packages"
          component={StorePackagesPage}
          options={{ headerShown: false, title: t`Packages` }}
        />
        <Stack.Screen
          name="ProductDetail"
          component={StoreProductDetailPage}
          options={{ headerShown: false, title: t`Product Detail` }}
        />
        <Stack.Screen
          name="ProductOrder"
          component={StoreProductOrderPage}
          options={{ headerShown: false, title: t`Product Order` }}
        />
      </Stack.Navigator>
    </VStack>
  );
};
